import { memo } from 'react';
import { Tooltip, useTheme } from '@material-ui/core';
import { ProjectsIcon } from '@room-match/shared-ui-components';
import ProgressBar from 'shared/components/ProfileProgressBar/ProgressBar';
import { ROUTES } from 'shared/constants/ROUTES';
import {
  Header,
  HLeft,
  HeaderTitle,
  Name,
  Count,
  AddButton,
  HRight,
  CompletionCont,
  Percent,
} from '../../image-video-audio.styles';
import { useHistory } from 'react-router-dom';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { COLORS } from 'shared/constants/COLORS';
const {
  ERROR_TEXT,
  WARNING_CIRCULAR_PROGRESS_BAR,
  ERROR_CIRCULAR_PROGRESS_BAR,
  WARNING_TEXT,
  DARK_CIRCULAR_PROGRESS_BAR_BACKGROUND,
  GRAY_CIRCULAR_PROGRESS_BACKGROUND,
} = COLORS;

interface DocumentHeaderProps {
  documentShownLength: number;
  allDocumentLength: number;
  permissions?: string[];
  nonRepre: boolean;
  handleAddModal: VoidFunction;
}

const DocumentHeader = ({
  documentShownLength,
  allDocumentLength,
  permissions,
  nonRepre,
  handleAddModal,
}: DocumentHeaderProps) => {
  const { width } = useWindowDimensions();
  const theme = useTheme();
  const history = useHistory();
  const completion = () => {
    switch (documentShownLength) {
      case 0:
        return 0;
      default:
        return 100;
    }
  };

  return (
    <Header>
      <HLeft>
        <ProjectsIcon
          htmlColor={COLORS.PRIMARY}
          style={{ width: width < 960 ? 30 : 40, height: width < 960 ? 30 : 40, alignSelf: 'center' }}
        />
        <HeaderTitle>
          <Name>Documents</Name>
          <Count>{documentShownLength ? `${documentShownLength} of ${allDocumentLength} used` : 'none'}</Count>
        </HeaderTitle>
        {width < 960 && (
          <AddButton
            onClick={() => {
              history.push(`${ROUTES.TALENT.MEDIA}/documents`);
            }}
          >
            EDIT
          </AddButton>
        )}
        {width < 960 && <AddButton style={{ marginLeft: 10 }}>ADD</AddButton>}
      </HLeft>
      <HRight>
        <CompletionCont>
          <Percent
            style={{
              color: `${completion() === 100 ? WARNING_TEXT : completion() > 50 ? WARNING_TEXT : ERROR_TEXT}`,
            }}
          >
            {completion()}% Complete
          </Percent>
          <ProgressBar
            borderRadius={8}
            percent={completion()}
            completeColor={`${completion() === 100 ? WARNING_CIRCULAR_PROGRESS_BAR : completion() > 50 ? WARNING_CIRCULAR_PROGRESS_BAR : ERROR_CIRCULAR_PROGRESS_BAR}`}
            backgroundColor={
              theme.palette.type === 'dark' ? DARK_CIRCULAR_PROGRESS_BAR_BACKGROUND : GRAY_CIRCULAR_PROGRESS_BACKGROUND
            }
          />
        </CompletionCont>
        {width > 960 && (
          <AddButton
            onClick={() => {
              history.push(`${ROUTES.TALENT.MEDIA}/documents`);
            }}
          >
            EDIT
          </AddButton>
        )}
        {width > 960 && (
          <>
            {!permissions?.includes('Documents') && permissions && !nonRepre ? (
              <>
                <Tooltip
                  title="Your agency has disabled the ability to edit the media on this profile, use the media manager to upload your files so they are accessible to your agency to include on your profile."
                  placement="top"
                  PopperProps={{ style: { marginBottom: -10 } }}
                >
                  <div style={{ opacity: 0.5 }}>
                    <AddButton
                      onClick={(e: any) => {
                        e.stopPropagation();
                        handleAddModal();
                      }}
                      disabled
                      style={{ fontSize: 11 }}
                    >
                      ADD DOCUMENTS
                    </AddButton>
                  </div>
                </Tooltip>
              </>
            ) : (
              <>
                <AddButton
                  onClick={(e: any) => {
                    e.stopPropagation();
                    handleAddModal();
                  }}
                  style={{ fontSize: 11 }}
                >
                  ADD DOCUMENTS
                </AddButton>
              </>
            )}
          </>
        )}
      </HRight>
    </Header>
  );
};

export default memo(DocumentHeader);
